import React from "react";
import { Card, CardBody, Button, Row, Col } from "reactstrap";
import { connect } from "react-redux";
import ReactTable from "react-table";
import TablePagination from "components/Table/TablePagination";
import RowActions, {
  editAction,
  deleteAction,
  viewAction,
} from "components/Table/RowActions";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine";
import loadingAction from "../../core/redux/actions/loadingAction";
import strings from "../../core/translate";
import { Scopes } from "../../shared/scopes.enum";
import { FormModal } from "../../components/Form/FormKit";
import PageHeader from "../../components/Page/PageHeader";
import VehicleSpecForm from "./VehicleSpecForm";

// The vehicle specs a client picks from when adding a car (GCC, American, …).
// Retiring one keeps it on the cars that carry it but stops offering it.
class VehicleSpecList extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataSource: [],
      formOpen: false,
      editing: null,
    };
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    this.callPage();
  }

  callPage = async () => {
    const response = await this.engine.getItem("vehicle-specs");
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        dataSource: response.data.items.map((item, key) => ({
          id: key,
          data: item,
          name: item.name,
          isActive: item.isActive,
        })),
      });
    } else {
      this.setState({ isLoading: false });
    }
    this.props.loadingAction(false);
  };

  handleAdd = () => this.setState({ formOpen: true, editing: null });

  handleEdit = (index) =>
    this.setState({
      formOpen: true,
      editing: this.state.dataSource[index].data,
    });

  handleCloseForm = () => this.setState({ formOpen: false, editing: null });

  handleSaved = () =>
    this.setState({ formOpen: false, editing: null }, this.callPage);

  handleDelete = async (item) => {
    if (!window.confirm(strings.confirmdelete)) return;
    this.props.loadingAction(true);
    const result = await this.engine.deleteItem("vehicle-specs", item.id);
    if (result) {
      this.callPage();
    }
    this.props.loadingAction(false);
  };

  handleActions = (index, item, canWrite) => (
    <RowActions
      actions={[
        canWrite
          ? editAction(() => this.handleEdit(index))
          : viewAction(() => this.handleEdit(index)),
        deleteAction(() => this.handleDelete(item), canWrite),
      ]}
    />
  );

  render() {
    const { dataSource, isLoading, formOpen, editing } = this.state;
    const canWrite = this.hasPermission([Scopes.VEHICLES_MAKES_WRITE]);

    const columns = [
      { Header: strings.name, accessor: "name" },
      {
        Header: strings.active,
        accessor: "isActive",
        sortable: false,
        filterable: false,
        Cell: (row) => (row.value ? strings.yes : strings.no),
      },
      {
        Header: strings.actions,
        accessor: "id",
        sortable: false,
        filterable: false,
        Cell: (row) =>
          this.handleActions(row.index, row.original.data, canWrite),
      },
    ];

    return (
      <div className="content">
        <PageHeader
          icon="nc-icon nc-delivery-fast"
          title={strings.vehicle_specs}
          subtitle={strings.vehicle_specs_subtitle}
          count={dataSource.length > 0 ? dataSource.length : undefined}
        >
          {canWrite && (
            <Button color="primary" onClick={this.handleAdd}>
              <i className="nc-icon nc-simple-add" /> {strings.add_vehicle_spec}
            </Button>
          )}
        </PageHeader>
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <ReactTable
                  previousText={strings.previous}
                  nextText={strings.next}
                  loadingText={strings.loading}
                  noDataText={strings.nodata}
                  pageText={strings.page}
                  data={dataSource}
                  defaultFilterMethod={this.filterCaseInsensitive}
                  filterable
                  loading={isLoading}
                  columns={columns}
                  defaultPageSize={10}
                  showPaginationTop={false}
                  showPaginationBottom
                  PaginationComponent={TablePagination}
                  className="-striped -highlight primary-pagination"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <FormModal
          isOpen={formOpen}
          onClose={this.handleCloseForm}
          icon="nc-icon nc-delivery-fast"
          title={
            editing ? `${strings.edit} ${strings.vehicle_spec}` : strings.add_vehicle_spec
          }
          subtitle={editing ? editing.name : ""}
        >
          <VehicleSpecForm
            key={(editing && editing.id) || "new"}
            item={editing}
            onSaved={this.handleSaved}
            onCancel={this.handleCloseForm}
          />
        </FormModal>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadingAction: (payload) => dispatch(loadingAction(payload)),
});

export default connect(null, mapDispatchToProps)(VehicleSpecList);
